 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"casino-casino-module-ngfactory":"casino-casino-module-ngfactory","common":"common","scratch-scratch-module-ngfactory":"scratch-scratch-module-ngfactory","default~bundles-bundles-module-ngfactory~dashboard-dashboard-module-ngfactory":"default~bundles-bundles-module-ngfactory~dashboard-dashboard-module-ngfactory","bundles-bundles-module-ngfactory":"bundles-bundles-module-ngfactory","default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~lottery-lottery-mo~edf7f9fb":"default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~lottery-lottery-mo~edf7f9fb","default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~shared-contact-us-~73af7409":"default~dashboard-dashboard-module-ngfactory~lotteries-lotteries-module-ngfactory~shared-contact-us-~73af7409","lotteries-lotteries-module-ngfactory":"lotteries-lotteries-module-ngfactory","default~dashboard-dashboard-module-ngfactory~shared-contact-us-contact-us-module-ngfactory":"default~dashboard-dashboard-module-ngfactory~shared-contact-us-contact-us-module-ngfactory","dashboard-dashboard-module-ngfactory":"dashboard-dashboard-module-ngfactory","shared-contact-us-contact-us-module-ngfactory":"shared-contact-us-contact-us-module-ngfactory","default~lottery-lottery-module-ngfactory~shared-cart-cart-module-ngfactory~shared-faq-faq-module-ngf~6a85a35a":"default~lottery-lottery-module-ngfactory~shared-cart-cart-module-ngfactory~shared-faq-faq-module-ngf~6a85a35a","shared-cart-cart-module-ngfactory":"shared-cart-cart-module-ngfactory","shared-faq-faq-module-ngfactory":"shared-faq-faq-module-ngfactory","lottery-lottery-module-ngfactory":"lottery-lottery-module-ngfactory","help-bonus-bonus-module-ngfactory":"help-bonus-bonus-module-ngfactory","help-cookie-policy-cookie-policy-module-ngfactory":"help-cookie-policy-cookie-policy-module-ngfactory","help-exclusive-offer-terms-exclusive-offer-terms-module-ngfactory":"help-exclusive-offer-terms-exclusive-offer-terms-module-ngfactory","help-exclusive-offer-terms2-exclusive-offer-terms2-module-ngfactory":"help-exclusive-offer-terms2-exclusive-offer-terms2-module-ngfactory","help-fifteen-discount-fifteen-discount-module-ngfactory":"help-fifteen-discount-fifteen-discount-module-ngfactory","help-fifty-refund-fifty-refund-module-ngfactory":"help-fifty-refund-fifty-refund-module-ngfactory","help-first-ticket-free-first-ticket-free-module-ngfactory":"help-first-ticket-free-first-ticket-free-module-ngfactory","help-five-for-one-five-for-one-module-ngfactory":"help-five-for-one-five-for-one-module-ngfactory","help-five-for-two-five-for-two-module-ngfactory":"help-five-for-two-five-for-two-module-ngfactory","help-five-tickets-free-five-tickets-free-module-ngfactory":"help-five-tickets-free-five-tickets-free-module-ngfactory","help-four-for-one-four-for-one-module-ngfactory":"help-four-for-one-four-for-one-module-ngfactory","help-four-for-two-four-for-two-module-ngfactory":"help-four-for-two-four-for-two-module-ngfactory","help-gamerules-gamerules-module-ngfactory":"help-gamerules-gamerules-module-ngfactory","help-one-ticket-free-one-ticket-free-module-ngfactory":"help-one-ticket-free-one-ticket-free-module-ngfactory","help-privacy-notice-privacy-notice-module-ngfactory":"help-privacy-notice-privacy-notice-module-ngfactory","help-rgp-rgp-module-ngfactory":"help-rgp-rgp-module-ngfactory","help-safety-safety-module-ngfactory":"help-safety-safety-module-ngfactory","help-six-for-three-six-for-three-module-ngfactory":"help-six-for-three-six-for-three-module-ngfactory","help-ten-discount-ten-discount-module-ngfactory":"help-ten-discount-ten-discount-module-ngfactory","help-ten-for-five-ten-for-five-module-ngfactory":"help-ten-for-five-ten-for-five-module-ngfactory","help-terms-terms-module-ngfactory":"help-terms-terms-module-ngfactory","help-three-for-one-three-for-one-module-ngfactory":"help-three-for-one-three-for-one-module-ngfactory","help-twenty-discount-twenty-discount-module-ngfactory":"help-twenty-discount-twenty-discount-module-ngfactory","help-two-for-one-two-for-one-module-ngfactory":"help-two-for-one-two-for-one-module-ngfactory","help-two-tickets-free-two-tickets-free-module-ngfactory":"help-two-tickets-free-two-tickets-free-module-ngfactory","help-wild-chase-tour-wild-chase-tour-module-ngfactory":"help-wild-chase-tour-wild-chase-tour-module-ngfactory","insta-games-insta-games-module-ngfactory":"insta-games-insta-games-module-ngfactory","shared-about-us-about-us-module-ngfactory":"shared-about-us-about-us-module-ngfactory","shared-bonus-policy-bonus-policy-module-ngfactory":"shared-bonus-policy-bonus-policy-module-ngfactory","shared-page-maintenance-break-page-maintenance-break-module-ngfactory":"shared-page-maintenance-break-page-maintenance-break-module-ngfactory","shared-page404-page404-module-ngfactory":"shared-page404-page404-module-ngfactory","shared-teamplay100-teamplay100-module-ngfactory":"shared-teamplay100-teamplay100-module-ngfactory","shared-teamplay200-teamplay200-module-ngfactory":"shared-teamplay200-teamplay200-module-ngfactory","shared-unsubscribe-unsubscribe-module-ngfactory":"shared-unsubscribe-unsubscribe-module-ngfactory","shared-wagering-table-wagering-table-module-ngfactory":"shared-wagering-table-wagering-table-module-ngfactory","winaija-local-draw-local-draw-module-ngfactory":"winaija-local-draw-local-draw-module-ngfactory"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
